import NsContent from 'components/common/ns-content/NsContent';

import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { toNucleusAddress } from 'utils/nucAddressFormat';
import { useNavigation } from 'hooks/useNavigation';

export const testId = 'addressPlaybackTestId';

type AddressPlaybackProps = {
  address?: {
    houseNameNumber?: number;
    addressLine1?: string;
    addressLine2?: string;
    postalTown?: string;
    county?: string;
    postcode: string;
    displayName: string;
  };
};

export const AddressPlayback = ({ address }: AddressPlaybackProps) => {
  const { eventTypes, next } = useNavigation();

  const addPostcodeToDisplayName = (address) => {
    if (!address) return address;

    const isMissingPostcode = !address?.displayName
      ?.toLowerCase()
      .includes(address?.postcode?.toLowerCase());

    if (isMissingPostcode) {
      return {
        ...address,
        displayName: `${address.displayName}, ${address.postcode}`
      };
    }

    return address;
  };

  const nucAddress = toNucleusAddress(addPostcodeToDisplayName(address));

  const handleEditAddress = () => {
    next({
      eventType: eventTypes.EDIT_ADDRESS,
      wasVisited: true
    });
  };

  return (
    <NsContent data-testid={testId}>
      <NsDescriptionList>
        {[
          {
            term: 'Address',
            description: [
              <>{address && <p>{nucAddress.label}</p>}</>,
              <>
                <NsSecondaryCta icon="" onClick={handleEditAddress}>
                  Edit address
                </NsSecondaryCta>
              </>
            ]
          }
        ]}
      </NsDescriptionList>
    </NsContent>
  );
};
